import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,AlertController,Platform } from 'ionic-angular';

import { Http } from '@angular/http';
import { MenuController } from 'ionic-angular';
import { Commontask } from '../../providers/commontask'
import { Webservice } from '../../providers/webservice'
import { Storagehelper } from '../../providers/storagehelper'
import { Events } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';
/**
 * Generated class for the CategorypagesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-categorypages',
  templateUrl: 'categorypages.html',
})
export class CategorypagesPage extends Commontask {

	public categoryid;
	public categoryDetail;

  constructor(public navCtrl: NavController, public navParams: NavParams,public menuctrl: MenuController,public http:Http,public webservice:Webservice,public loader:LoadingController,public storage:Storagehelper,public event:Events,public alertCtrl:AlertController,public platform:Platform,public socialShare:SocialSharing) {
		super(menuctrl,event,platform,socialShare,alertCtrl);
		this.categoryid=navParams.get('categoryId');
		this.categoryDetail={category_title:''};
		this.loadCategoryDetail();	
	}

	loadCategoryDetail(){
		this.storage.queryStorage("menuCategories",'category_id',this.categoryid).then((data)=>{

				this.categoryDetail=data[0];
        this.categoryDetail.menuPages.forEach((e,i)=>{
            e.categoryid=this.categoryid;
            if(e.PageTypeID==1){
              e.menuIcon="fa-file-text-o"; //page text
            }else if(e.PageTypeID==2){
              e.menuIcon="fa-volume-up"; //page sound
            }else if(e.PageTypeID==4){
              e.menuIcon="fa-film"; //page video
            }else if(e.PageTypeID==3){
              e.menuIcon="fa-square-o"; //page slider
            }
        })

		});
	}

 
   ionViewDidEnter(){
    // if(this.audioplayer.src!=""){
    //   this.Play();
    // }
    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewCanEnter(){

    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewWillEnter(){
    
    this.event.publish('app:changeHeaderBackground'); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/categorypages/categorypages.ts